var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingTentamus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ed01KyxFTCk1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57 59",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#ed01KyxFTCk2 {animation: ed01KyxFTCk2_c_o 2300ms linear infinite normal forwards}@keyframes ed01KyxFTCk2_c_o { 0% {opacity: 0} 8.695652% {opacity: 0} 52.173913% {opacity: 0.93} 100% {opacity: 0.93}} #ed01KyxFTCk3 {animation: ed01KyxFTCk3_c_o 2300ms linear infinite normal forwards}@keyframes ed01KyxFTCk3_c_o { 0% {opacity: 0} 30.434783% {opacity: 0} 86.956522% {opacity: 1} 100% {opacity: 1}} #ed01KyxFTCk4 {animation: ed01KyxFTCk4_c_o 2300ms linear infinite normal forwards}@keyframes ed01KyxFTCk4_c_o { 0% {opacity: 0} 39.130435% {opacity: 1} 100% {opacity: 1}} #ed01KyxFTCk5 {animation: ed01KyxFTCk5_c_o 2300ms linear infinite normal forwards}@keyframes ed01KyxFTCk5_c_o { 0% {opacity: 0} 17.391304% {opacity: 0} 69.565217% {opacity: 0.9} 100% {opacity: 0.9}}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ed01KyxFTCk2",
    d: "M22.1,50.1c-5.1.4-6.9,2.4-7.5,4.3c4.4,2.7,9.6,4.3,15.1,4.3c6.1,0,11.8-1.9,16.5-5.2-5.9-1.5-17.4-4-24.1-3.4Z",
    opacity: 0,
    fill: "#15be7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ed01KyxFTCk3",
    d: "M38.4,36.8c4,6.2,8.9,11,11.7,13.5c2.8-2.8,5-6.1,6.5-9.8-3.8-1.7-11.2-4.5-18.2-3.7Z",
    opacity: 0,
    fill: "#15be7a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ed01KyxFTCk4",
    d: "M29.7,0.900024h.2c2.5,0,4.8.300006,7.2.900006-.6.5-1.3.99999-1.9,1.59999C31.4,6.80002,27.4,12.9,29.3,23c2.4,12,10.6,21.8,16.1,27.2C39.7,48.9,30.7,47,24.2,47c-.9,0-1.6,0-2.4.1-4.6.4-7.7,2-9.3,4.6-.2.3-.3.5-.4.8C5.10001,47.1,0.900007,38.7,1.00001,29.6C1.00001,13.7,13.9,0.900024,29.7,0.900024Z",
    opacity: 0,
    fill: "#15be7a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ed01KyxFTCk5",
    d: "M51.8,36.2c.1-.8.2-1.6.2-2.4c0-7.9-6.4-14.4-14.3-14.4-2,0-3.9.4-5.7,1.1.1.6.2,1.3.3,1.9.8,4.2,2.5,8.1,4.4,11.6c5.5-.9,11.2.7,15.1,2.2Z",
    opacity: 0,
    fill: "#15be7a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingTentamus);
export default __webpack_public_path__ + "static/media/LoadingTentamus.bdd4590618011f12950b0101b4caa815.svg";
export { ForwardRef as ReactComponent };